<template>
  <div
    class="-mr-4 bg-white col-span-1 overflow-hidden shadow rounded-lg divide-y divide-gray-200 w-full"
  >
    <div class="px-4 py-3 sm:px-4">
      <div
        class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap"
      >
        <div class="ml-4 mt-2">
          <h3 class="text-base leading-6 font-medium text-gray-900">
            {{ $t('message.reports.detenciones.paretodetenciones') }}: <b>{{this.currentDevice.name}}</b>
          </h3>
        </div>
        <div class="ml-2 mt-2 flex-shrink-0">
          <button
            @click="downloadExcel"
            type="button"
            class="relative inline-flex items-center px-2 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md bg-white hover:bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            <svg
              v-if="downloading"
              class="animate-spin -ml-1 mr-3 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
              ></circle>
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            {{ $t('message.reports.detenciones.descargarexcel') }}
          </button>
        </div>
      </div>
    </div>
    <div class="px-4 py-6">
      <div id="chart3" v-if="reportnav.distributiontime !== undefined ? reportnav.distributiontime : false">
        <vue-apex-charts
          type="bar"
          height="250"
          :options="chartOptionsBarStacked"
          :series="seriesBarStacked">
        </vue-apex-charts>
      </div>
      <div id="chart2" v-if="reportnav.pareto !== undefined ? reportnav.pareto : false">
        <vue-apex-charts
          type="bar"
          height="250"
          :options="chartOptions"
          :series="series"
        ></vue-apex-charts>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import { getUnixTime } from 'date-fns';
import axios from 'axios';
export default {
  name: 'report-detenciones',
  components: { VueApexCharts },
  mounted() {
    this.fetchData();
  },
  props: {
    range: {
      type: Object,
      required: true
    },
    currentDevice: {
      type: Object,
      required: true
    },
    reportnav: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  watch: {
    range() {
      this.fetchData();
    },
    currentDevice() {
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      let start = getUnixTime(this.range.start);
      let end = getUnixTime(this.range.end);
      const response = await this.$http.get(
        `codstates?devid=${this.currentDevice.devid}&start=${start}&end=${end}`
      );


      let data = response.data.codstates.map(val => {
        return { y: val.time_s, x: val.desc };
      });
      this.series = [{ name: 'tiempos', data: data }];

      if (this.reportnav.distributiontime !== undefined ? this.reportnav.distributiontime : false){
        const response_dtd = await this.$http.get(`/reports?report=distribution_time_dev&devid=${this.currentDevice.devid}&start=${start}&end=${end}`);
        this.seriesBarStacked = response_dtd.data.map((value)=>{
          return {
            name: value.name,
            data: [value.time],
            unit: value.unit
          }
        })
      }


    },

    async downloadExcel() {
      this.downloading = true;
      let start = getUnixTime(this.range.start);
      let end = getUnixTime(this.range.end);
      const url = `reports?report=dets&start=${start}&end=${end}&device=${this.currentDevice.devid}`;
      let response = await this.$http.get(url);
      if (response.status === 200) {
        const baseURL = process.env.VUE_APP_ROOT_CONTROLLER;
        const url = baseURL + 'xlsxreports/' + response.data;
        axios
          .get(url, { responseType: 'blob' })
          .then(r => {
            const blob = new Blob([r.data], {
              type: 'application/vnd.ms-excel'
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            console.log('response', response.data);
            link.download = response.data;
            link.click();
            URL.revokeObjectURL(link.href);
          })
          .catch(console.error);
      }
      this.downloading = false;
    }
  },
  data() {
    return {
      downloading: false,
      series: [],
      chartOptions: {
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + ' horas';
            }
          }
        }
      },
      // Bar chart
      seriesBarStacked: [],
      chartOptionsBarStacked: {
        title: {
          text: 'Distribución de tiempos de detención por familia',
          align: 'left',
          style: {
            fontSize: '14px'
          }
        },
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%'
        },
        xaxis: {
          categories: ["   "],
        },
        colors: ["#68D138", "#DB4437","#F46036", "#775DD0", "#546E7A", "#253A92","#FEB019"],
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        tooltip: {
          enabled: true,
          x: {
            show: false
          },
          y: {
            formatter: (y, config) => {
              if (this.seriesBarStacked == []){
                return ''
              }
              let unit = this.seriesBarStacked[config.seriesIndex].unit
              if (unit === 'minutes'){
                return `${y} minuto${y==1?'':'s'}`;
              }
              else if (unit==='hours') {
                return `${Number((y/60).toFixed(2))} hora${y==1?'':'s'}`;
              }
              else if (unit==='mix'){
                let hours = Math.floor(y / 60)
                let minutes = y % 60
                const result = `${hours>0?`${hours} hora${hours==1?'':'s'}`:''} ${minutes>0?`${minutes} minuto${minutes==1?'':'s'}`:''}`
                return result
              }
              return ''
            }
          }
        }
      },
    };
  }
};
</script>
